import React from "react";
import "./about.css";
import aboutImage from "../../assets/AboutSection/about-image.svg";
import icon1 from "../../assets/AboutSection/memory-driven-intelligence.svg";
import icon2 from "../../assets/AboutSection/context-aware-execution.svg";
import icon3 from "../../assets/AboutSection/hierarchical-planning.svg";
import icon4 from "../../assets/AboutSection/agent-computer-interface.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";

export default function About() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.25 });
  const points = [
    {
      heading: "Memory-Driven Intelligence",
      icon: icon1,
    },
    {
      heading: "Context-Aware Execution",
      icon: icon2,
    },
    {
      heading: "Hierarchical Planning",
      icon: icon3,
    },
    {
      heading: "Agent-Computer Interface",
      icon: icon4,
    },
  ];

  return (
    <section
      className={`about-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="one"
    >
      <div className="container">
        <div className="section-heading">
          <div className="about-section-wrapper">
            <div className="about-section-left">
              <div className="heading-tag">
                <span>About</span>
              </div>
              <div className="about-heading-description">
                <h2>Navigate Any GUI Like a Pro with AI Aviator</h2>
                <p>
                  AI Aviator simplifies software navigation by identifying UI
                  elements, understanding screen layouts, and executing actions
                  efficiently without code changes.
                </p>
              </div>
              <div className="pointers-list">
                {points.map((point, index) => (
                  <div className="point col-6" key={index}>
                    <img src={point.icon} alt="about-point" />
                    <p>{point.heading}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="about-section-right">
              <img src={aboutImage} alt="about-image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
